class BundleUtil {
    /**
     * Takes a bundle-relative path and converts it to a fully qualified URL
     * @param {string} path - path relative to the bundle (should start with a slash)
     */
    static getFullyQualifiedURL(path) {
        // url-loader will convert files to data uri's instead of returning the bundle-relative path
        // if we've received a data uri, just return it directly
        if (path.startsWith('data:')) {
            return path;
        }

        const bundleLocation = window.model.BundleLocation;

        return bundleLocation + path;
    }

    // Returns whether this is prod or dev (we only care if it's prod or non-prod)
    static getTenant() {
        return (process.env.NODE_ENV === "production" && (window.location.hostname.indexOf('vistaprint') !== -1
            || window.location.hostname.indexOf('vpcustomercare') !== -1)) ? "" : "dev";
    }
}

export default BundleUtil;



// WEBPACK FOOTER //
// ./src/utils/BundleUtil.js